<template>
  <router-view />
</template>

<style lang="scss"></style>

<script>
export default {
  beforeMount() {

  }
}
</script>